import { ServerURI } from '../globals';

let backendHealthStatus = null;
let healthCheckPromise = null;

const cache = new Map();
const CACHE_DURATION = 5000; // 5 seconds

export const getCachedData = (key) => {
    const data = cache.get(key);
    if (data && Date.now() - data.timestamp < CACHE_DURATION) {
        return data.value;
    }
    return null;
};

export const setCachedData = (key, value) => {
    cache.set(key, { value, timestamp: Date.now() });
};

export const clearCachedData = (key) => {
    if (key === undefined) {
        cache.clear();
    } else {
        cache.delete(key);
    }
};

export const checkBackendHealth = async () => {
    // Skip health check in development if we know backend is running
    if (process.env.NODE_ENV === 'development') {
        return true; // Assume backend is healthy in dev
    }
    
    try {
        // Add timeout to prevent hanging
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 1000); // 1 second timeout

        const response = await fetch(`${ServerURI}/health`, {
            credentials: 'include',
            headers: {
                'Accept': 'application/json'
            },
            signal: controller.signal
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
            console.warn('Backend health check failed:', response.status);
            return false;
        }

        const data = await response.json();
        return data.status === 'ok';
    } catch (error) {
        // Don't log CORS errors in production
        if (error.name === 'AbortError') {
            console.warn('Backend health check timed out');
        } else if (process.env.NODE_ENV === 'development') {
            console.warn('Backend health check error:', error);
        }
        // Return true to allow the app to continue even with health check failures
        return true;
    }
};

export const clearCache = () => {
  cache.clear();
  backendHealthStatus = null;
}; 